import ApiResponseV2 from '../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2';
import GenericCrudServiceV2 from '../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2';
import HttpClientV2 from '../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2';
import Property from '../models/Property';

class PropertiesService extends GenericCrudServiceV2<Property> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  updateProperty(instance: Property): Promise<ApiResponseV2<Property>> {
    return HttpClientV2.put(`${this.path}`, instance);
  }

  deleteProperty(instance: Property): Promise<ApiResponseV2<String>> {
    return HttpClientV2.delete(`${this.path}?id=${instance.id}`);
  }
}

export default new PropertiesService('/ensolvers-ops/properties');
